import { useSelector } from "react-redux";
import { MapIndicator } from "../index";
import { getIcons } from "_helpers";
import { selectMapAlertCount, selectMapStopCount } from "_store/selectors/map.selector";
import { useMemo } from "react";

export { DataAlertIndicator }

/**
 * Composant de la map affichant les informations (KPI) en haut à gauche
 * Indique le nombre de bus en alerte 3 et en stop 4
 * Un clic sur l'un des éléments va filtrer l'affichage des bus
 * @returns 
 */
function DataAlertIndicator({ toggleAlertLevel3, toggleStopLevel4 })  {

    const alertCount = useSelector(selectMapAlertCount);
    const stopCount = useSelector(selectMapStopCount);

    const data = useMemo(() => [
        {
            title: "Alertes 3",
            value: alertCount,
            icon: getIcons("busAlertOutlinedWhite"),
            color: 'primary-orange',
            isActiveClass: 'bg-primary-orange text-global-white',
            clickable: true,
            isActive: true,
            action: () => toggleAlertLevel3()
        },
        {
            title: "Stops 4",
            value: stopCount,
            icon: getIcons("busAlertOutlinedWhite"),
            color: 'primary-red',
            isActiveClass: 'bg-primary-red text-global-white',
            clickable: true,
            isActive: true,
            action: () => toggleStopLevel4()
        }
    ], [alertCount, stopCount, toggleAlertLevel3, toggleStopLevel4]);
    return (
        <div className={'flex item-center mt-2'}>
            {data.map((e, index) => {
                return <MapIndicator info={e} key={index} />
            })}
        </div>
    )
}